import React, { memo, useCallback, useEffect } from 'react';

import { useStore } from 'hooks';

import * as T from './interfaces';
import { RequestLocation } from './RequestLocation';

export const Container = memo(({ toggleLatLng }: T.IRequestLocation) => {
  const { handleCreateOverlay, handleRemoveOverlay } = useStore();

  const handleAcceptPosition = useCallback(
    position => {
      const latLng = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      toggleLatLng(latLng);
      handleRemoveOverlay();
    },
    [handleRemoveOverlay, toggleLatLng],
  );

  const handleRecusePosition = useCallback(() => {
    toggleLatLng(null);
    handleRemoveOverlay();
  }, [handleRemoveOverlay, toggleLatLng]);

  const handleRequestUserLocation = useCallback(() => {
    if ('geolocation' in navigator) {
      handleCreateOverlay();
      navigator.geolocation.getCurrentPosition(
        handleAcceptPosition,
        handleRecusePosition,
      );
    } else {
      alert(
        'Sinto muito, mas os serviços de geolocalização não são suportados pelo seu navegador.',
      );
    }
  }, [handleCreateOverlay, handleAcceptPosition, handleRecusePosition]);

  return (
    <RequestLocation
      id="requestLocationToPlaces"
      onRequestLocation={handleRequestUserLocation}
    />
  );
});
